import { useLang } from '@/i18n';
import EfBanner from '@elem/ui/ef-banner';
import { useRouter } from 'next/router';
import { useProductStore } from './../../../ProductProvider';
import styles from './index.module.scss';

export default function TheComp() {
    const { locale = 'us' } = useRouter();
    const { pageStatus } = useProductStore();
    const NAImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724566389277/aa1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724566389806/aa2.jpg',
    };
    const EUImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724989743551/eu1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724989761070/eu2.jpg',
    };
    const UKImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724989902943/uk1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724989915975/uk2.jpg',
    };
    const PHImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751089497852/kv.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751089497667/kv-m.jpg',
    };

    const imgLocale: any = {
        us: NAImg,
        ca: NAImg,
        br: NAImg,
        mx: NAImg,
        uk: UKImg,
        eu: EUImg,
        de: EUImg,
        fr: EUImg,
        it: EUImg,
        es: EUImg,
        nl: EUImg,
        ph: PHImg,
    };
    const imgA = imgLocale[locale] || imgLocale['eu'];
    const { t } = useLang('theProduct.Banner');
    const configs = {
        title: t('title'),
        desc: t('desc'),
        pc: imgA.pc,
        h5: imgA.h5,
        btn_text: locale === 'kr' ? '' : t('btn'),
        btn_link: pageStatus === 'statusA' ? '' : 'https://www.youtube.com/embed/at2yA3hKyak?si=fDTNu9X5YR_pePgs',
    };

    return (
        <div className={styles.TheComp}>
            <EfBanner {...configs} theme="black" />
        </div>
    );
}
